exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.searching .v-text-field {\n  padding-top: 10px;\n  margin-right: 10px;\n}\n.searching .v-text-field > .v-input__control > .v-input__slot:before {\n  border-width: thin 0 1px 0;\n}\n.searching--closed {\n  padding-left: 0;\n  width: 0 !important;\n}\n.searching > * {\n  right: 8px;\n}\n.searching > .input-group {\nmargin-top: 6px;\n}\n.searching--closed > * {\n  display: none;\n}\n", ""]);

// exports
